
<template></template>
 
<script>
import router from "../router";
export default {
  created() {
    /**
     * Callback component required for Auth from the Help Hub header
     */
    let authCode = this.$route.query.code;
    if (authCode) {
      this.getCurrentAccessToken(window.location.href, null, process.env.VUE_APP_ENV)
        .then(response => {
          router.push({ path: "/all" });
        })
        .catch(error => {
          router.push({
            name: "error",
            params: {
              message: "The authentication response did not return Access code"
            }
          });
        });
    }
  },
  methods: {}
};
</script>